import { route, tag, type PageTour } from '../pageTour';

export const cameraConfigTour: PageTour = {
  id: 'page-camera-config',
  version: 1,
  title: 'Camera Configuration',
  summary: 'One camera\'s stream, recording and analytics settings.',
  match: route('/nodes/:nodeId/cameras/:cameraId/config'),
  steps: [
    {
      target: tag('camera-config-refresh'),
      title: 'Refresh',
      description: 'Read the current settings from the camera again, for example after changing them elsewhere.',
      side: 'bottom',
    },
    {
      target: tag('camera-config-preview'),
      title: 'Live preview',
      description: 'Watch the camera while you adjust it, so you can see each change take effect. Device facts are listed underneath.',
      side: 'right',
    },
    {
      target: tag('camera-config-tabs'),
      title: 'Settings sections',
      description: 'Switch between PTZ control, image, encoding, network and overlay settings. PTZ is only available on cameras that support it.',
      side: 'bottom',
    },
    {
      target: tag('camera-config-panel'),
      title: 'Change and apply',
      description: 'Adjust the settings here and apply them to send the change to the camera. You will be warned before leaving a tab with unsaved changes.',
      side: 'top',
    },
  ],
};
